export const checkStatus = (result) => {
    if (result.ok) {
        return result.json()
    }

    return Promise.reject(`Ошибка ${result.status}`)
}